module.exports = __webpack_public_path__ + "static/media/settingwhite.09991b9a.svg";